import { useMemo } from 'react';
import { useGetHasScope } from '../../auth/hooks/useGetHasScope';
import { useGetIsUngated } from '../../auth/hooks/useGetIsUngated';
import { GATE_COPILOT_COLLABORATE_INTERACTIVE_MODE, GATE_COPILOT_SALES_ACCESS, GATE_AGENT_AI_STUDIO, GATE_COPILOT_V2_INTERACTIVE_TOOLS } from '../constants';
import { useCollaborationParentState } from '../../hooks/useCollaborationParentState';
import { INTERACTIVE_MODE_PLUGIN } from '../../types/PluginTypes';
import { useIsUngatedForCopilotV2 } from './useIsUngatedForCopilotV2';
export const useHasSalesCopilotAccess = () => {
  const isUngated = useGetIsUngated();
  const getHasScope = useGetHasScope();

  /** Product scope for Sales GPT users
   * This scope is added to any user in 53
   * https://private.hubteam.com/atlas-internal/scopes/5835/hubspotters
   */
  const isSalesGPTUser = useMemo(() => {
    return getHasScope('sales-gpt-access');
  }, [getHasScope]);
  const isUngatedForSalesCopilot = useMemo(() => isUngated(GATE_COPILOT_SALES_ACCESS), [isUngated]);
  return isSalesGPTUser && isUngatedForSalesCopilot;
};

// TODO: clean this up once the BE version is rolled out.
export const useIsUngatedForInteractiveMode = () => {
  const isUngated = useGetIsUngated();
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  return useMemo(() => isUngated(GATE_COPILOT_COLLABORATE_INTERACTIVE_MODE) && !isUngatedForCopilotV2, [isUngated, isUngatedForCopilotV2]);
};

// This is the hook with interactive mode and the BE.
export const useHasCopilotV2InteractiveToolsAccess = () => {
  const isUngated = useGetIsUngated();
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  return isUngatedForCopilotV2 && isUngated(GATE_COPILOT_V2_INTERACTIVE_TOOLS);
};
export const useIsInteractiveModePluginEnabled = () => {
  const {
    allowedPlugins
  } = useCollaborationParentState();
  return allowedPlugins.includes(INTERACTIVE_MODE_PLUGIN);
};
export const useHasCopilotCollabInteractiveModeAccess = () => {
  const isUngatedForCollabInteractiveMode = useIsUngatedForInteractiveMode();
  const isInteractiveModePluginEnabled = useIsInteractiveModePluginEnabled();
  return isInteractiveModePluginEnabled && isUngatedForCollabInteractiveMode;
};
export const useHasChatAgentAccess = () => {
  const isUngated = useGetIsUngated();
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const isUngatedForChatAgent = useMemo(() => isUngated(GATE_AGENT_AI_STUDIO), [isUngated]);
  /** Chat Agents are only available on Copilot V2 */
  return isUngatedForCopilotV2 && isUngatedForChatAgent;
};